<template>
  <!--Footer-->
    <div class="container-expand-sm footer-part" id="footer">
        <br>
        <div class="container-sm">
            <ul class="footertag">
                <li>
                    <h6 ><router-link :to="{ name: 'terms-of-use' }" class="about">Terms of use</router-link></h6>
                </li>

                <li>
                    <h6> <router-link :to="{ name: 'faq' }" class="about">FAQ</router-link></h6>
                </li>

                <li>
                    <h6> <router-link :to="{ name: 'privacy-policy' }" class="about">Privacy Policy</router-link></h6>
                </li>

                <li>
                    <h6> <router-link :to="{ name: 'contact-us' }" class="about">Contact Us</router-link></h6>
                </li>

                <li>
                    <h6> <router-link :to="{ name: 'about-us' }" class="about">About Us</router-link></h6>
                </li>
            </ul>
            <hr>
            <div class="row ">
                <div class="col">
                    <h6>Restaurants</h6>
                    <a href="diaryqueen.html" class="about"><p>Dairy Queen</p></a>
                    <p>Dairy Queen Bahrain</p>
                    <p>Hakishusi</p>
                    <p>Magic work</p>
                    <p>Papa Johns</p>
                    <p>Papa Johns seef mall</p>
                    <p>Thai Express</p>
                </div>
                <div class="col">
                    <h6>Popular Cuisines</h6>
                    <p>American</p>
                    <p>Beverages</p>
                    <p>Breakfast</p>
                    <p>Burgers</p>
                    <p>Cafe</p>
                    <p>Ice Creams</p>
                    <p>italian</p>
                    <p>Pizza</p>
                    <p>Sandwiches</p>
                </div>
                <div class="col">
                    <h6>Popular Areas</h6>
                    <p>Bahrain</p>
                    <p>Manama</p>
                </div>
                <div class="col">
                    <h6>Follow Us On</h6>
                    <div class="row">
                        <!-- <div class="col-2">
                            <img src="/design/sigofood-images/facebook.png" style="width: 30px;">
                        </div>
                        <div class="col-2">
                            <img src="/design/sigofood-images/twitter.png" style="width: 30px;">
                        </div>
                        <div class="col-2">
                            <img src="/design/sigofood-images/instagram.png" style="width: 30px;">
                        </div> -->
                        <div class="col-12 d-flex">
                            <img src="/design/sigofood-images/facebook.png" style="width: 30px; margin-right: 10px;">
                            <img src="/design/sigofood-images/twitter.png" style="width: 30px; margin-right: 10px;">
                            <img src="/design/sigofood-images/instagram.png" style="width: 30px; margin-right: 10px;">
                        </div>
                    </div><br>
                    <a href="#">
                        <img src="/design/sigofood-images/appstore.png" style="width: 150px;">
                    </a>
                    <br><br>
                    <a href="https://play.google.com/store/apps/details?id=com.app.sigofoodcustomerapp">
                        <img src="/design/sigofood-images/googleplay.png" style="width: 150px;">
                    </a>
                </div>
            </div>
            <hr>
            <p style="text-align:center;">Copyright 2022 sigofood. All Rights Reserved</p> <br>
        </div>

    </div>

    <!-- Modal -->
    <!-- <div class="modal fade " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h5 class="d-grid mx-auto fw-semibold" id="exampleModalLabel">Logout</h5>
                    <div class="text-box">
                        <p class="">Are you sure you want to logout?</p>

                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn ok-button " data-bs-toggle="modal"
                        data-bs-target="#exampleModal">No</button>

                    <a  href="signin.html">
                        <button type="button" class="btn ok-button " data-bs-toggle="modal"
                        data-bs-target="#exampleModal">Yes</button>
                    </a>


                </div>
            </div>
        </div>
    </div> -->

    <!--Bootstrap JS-->    
    
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

